import { Component } from '@angular/core';
import { NavController, Events, LoadingController } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';
import { ServicesCommon } from './services.common';
import { RecipeDetailPage } from '../../../recipes/pages/recipe-detail/recipe-detail';


@Component({
	selector: 'page-services',
  	templateUrl: 'services.html'
})

export class ServicesPage extends PageBase {
	public pageSections:any;
	public loader: any;

	constructor(
		public settings: AppSettings,
		public events: Events,
		public nav: NavController,
		public userData: UserData,
		public common: ServicesCommon,
        public loadingCtrl: LoadingController
	) {
		super(settings, events, nav, userData);
		this.loader = this.loadingCtrl.create();
	}

	ngAfterViewInit() {
		
	}

	ionViewDidEnter() {
		
	}

	viewRecipeDetail(id) {
	    this.nav.push(RecipeDetailPage, { id: id });
	}
}





// WEBPACK FOOTER //
// ./src/modules/services/pages/services/services.ts